<template>
	<div id="app" class="clearfix" :class="{'isWxapp':$store.state.openId}" :style="{backgroundColor:$store.state.openId?$store.state.canvasBgColor:''}">
	<router-view/>
  <networkErrorMask></networkErrorMask>
	</div>
</template>

<script>
	import "./assets/css/reset.css";
  import networkErrorMask from "@/components/PublicAssembly/networkErrorMask.vue"
  // this.cssType == 1 ? import "./assets/css/tjcloud.css":''
	export default {
		name: 'App',
    components:{networkErrorMask},
		data() {
			return {
        lastTime: null, //最后一次点击的时间
        // currentTime: null, //当前点击的时间
				// timeOut: 10 * 60 * 1000 //设置超时时间： 10分钟
				dongdong:false,		//心脏咚咚
			}
		},
		mounted() {
			window.addEventListener('keyup',this.handleKeyup)
			window.addEventListener('click',this.handleClick)
			this.heartbeat()
		},
    beforeCreate() {
      let protocol = window.location.protocol
      // console.log(protocol,window.location)
      if(protocol.indexOf('https')!=-1){  //https 永捷机电
        this.$store.state.MQTT_SERVICE = "wss://mqtt.yonjie.com:8084/mqtt"
      }else if(document.domain!='iot.yonjie.com'&&document.domain!='localhost'){ //非https协议且不是永捷地址。则使用当前域名，打包时请把 &&document.domain!='localhost' 删除，避免客户本地局域网使用localhost当问出现mqtt地址问题
        this.$store.state.MQTT_SERVICE = "ws://"+ document.domain +":8083/mqtt"
      }
      // console.log(this.$store.state.MQTT_SERVICE)
    },
		created() {
      if(this.cssType == 1){
        // let url = ;
        require("@/assets/css/tjcloud.css")
        document.body.classList = 'TJCloud'
      }
			window.addEventListener('beforeunload', e => this.closeView(e))
			window.addEventListener('unload', e => {
        this.$store.state.mask = false
        console.log("unload")
      })
			// if(localStorage.getItem('isLook')){
			// 	console.log(nowTime-closeTime)
			// 	this.$store.state.isLook = localStorage.getItem('isLook')
			// }
			this.handleClick()
		},
		methods: {
			// 计算离线时间
			regLoginOut(){
				if(localStorage.getItem('closeTime')){
					let closeTime = localStorage.getItem('closeTime');
					let nowTime = new Date().getTime()
					if(nowTime-closeTime>30000){	//当离线时间超过30s，清除查看状态
						localStorage.removeItem('lastClickTime')
						localStorage.setItem('isLook',false)
						this.$store.state.isLook=false;
						localStorage.removeItem('closeTime')
					}else if(localStorage.getItem('isLook')){
						this.$store.state.isLook = localStorage.getItem('isLook')
					}
				}
			},
			// // 关闭或者刷新页面触发
			closeView(e){
			 	let closeTime = new Date().getTime()
			 	localStorage.setItem('closeTime',closeTime) //保存关闭时间
				clearInterval(this.timeInterval)
				clearInterval(this.dongdong)
        // 移除本地缓存
				localStorage.removeItem('OverdueTips');
				sessionStorage.removeItem('GetURL');
				sessionStorage.removeItem('wxGetURL');
				sessionStorage.removeItem('wxPostURL');
				sessionStorage.removeItem('PostURL');
				sessionStorage.removeItem('postFormURL');
				sessionStorage.removeItem('postNoJsonURL');
        // 初始化state参数值
        // console.log(this.$route)
        // console.log("closeView")
        this.$store.state.DragList=[]
        this.$store.state.ProductFeature = []
				// sessionStorage.setItem("store",JSON.stringify(this.$store.state))  //sessionStorage改为localstorage
        sessionStorage.setItem("store",JSON.stringify(this.$store.state))
        localStorage.setItem("store",JSON.stringify(this.$store.state))
      },
			// 键盘事件
			handleKeyup(e){
				if(localStorage.getItem('guestTime')&&!this.$store.state.isLook){
					localStorage.setItem('lastClickTime',new Date().getTime())
					clearInterval(this.timeInterval)
					this.lookTime(localStorage.getItem('guestTime'))
				}else{
					clearInterval(this.timeInterval)
					this.timeInterval=null
				}
			},
			// 鼠标点击事件
			handleClick(){
        // 监听全局点击时件，记录最后一次点击时间
				if(localStorage.getItem('guestTime')&&!this.$store.state.isLook){
					localStorage.setItem('lastClickTime',new Date().getTime())
					this.lookTime(localStorage.getItem('guestTime'))
					clearInterval(this.timeInterval)
				}else{
					clearInterval(this.timeInterval)
					this.timeInterval=null
				}
			},
      // 心跳包
			async heartbeat(){
				this.dongdong = setInterval(()=>{
					if(localStorage.getItem('loginState')==true||localStorage.getItem('loginState')=="true"){
						if(this.$store.state.openId!=''){
							this.wx_get('/UserProfile/ping').then(res=>{})
						}else{
							this.get('/UserProfile/ping').then(
                res=>{},
                // rej=>{
                //   if(rej=="Error: Network Error"){
                //     console.log("断网啦")
                //   }
                // }
              )
						}
            let mute = localStorage.getItem('mute')
            this.$store.state.mute = mute||0
            localStorage.setItem('pingTime',new Date().getTime())
					}
				},60000)
			}
		},

		beforeDestroy() {
			if(localStorage.getItem('OverdueTips')){
				localStorage.removeItem('OverdueTips');
			}
		},

	}
</script>

<style>
	#app {
		font-family: "微软雅黑", 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}
  .isWxapp{
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    overflow: auto;
  }
.tooltip{
	padding:8px;
}
.highcharts-tooltip{
	background-color:white;
	z-index:9999;
}
	body {
		overflow: hidden;
	}
	#app .amap-logo{
	    display: none !important;
	}
	#app .amap-copyright {
	    display: none !important;
	}
  .scroll{
    outline: none !important;
  }
  .scroll:focus-visible{
    outline:none !important;
  }
	/*body .el-date-table td.disabled div{
		color: #373737 !important;
	}*/
</style>



// WEBPACK FOOTER //
// src/App.vue